import { render, staticRenderFns } from "./addMetaData.vue?vue&type=template&id=561d2ae5"
import script from "./addMetaData.vue?vue&type=script&lang=js"
export * from "./addMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports